import { axios } from '@/utils/request'

export default{
  getWxMenus(){
    return axios.get('/api/services/app/Setting/GetWxMenus')
  },
  saveAndPublic(input){
    return axios.post('/api/services/app/Setting/SaveAndPublic',input)
  }
}